import React, { ReactNode } from "react";

import { useTranslation } from "utils";

import { Flex, Tag } from "components";

interface MineralFertilizerOptionLabelProps {
  name: ReactNode;
  hasUreaseInhibitor?: boolean;
  hasNitrificationInhibitor?: boolean;
  hasLowCarbonEmissions?: boolean;
}

export const MineralFertilizerOptionLabel = ({
  name,
  hasUreaseInhibitor,
  hasNitrificationInhibitor,
  hasLowCarbonEmissions,
}: MineralFertilizerOptionLabelProps) => {
  const { t } = useTranslation("practices");

  return (
    <Flex justify="space-between" align="center">
      {name}
      <Flex gap={8}>
        {hasLowCarbonEmissions && <Tag text={t("mineralFertilizers.lowCarbon")} colour="blue" size="small" />}
        {(hasUreaseInhibitor || hasNitrificationInhibitor) && <Tag text={t("mineralFertilizers.inhibited")} colour="green-200" size="small" />}
      </Flex>
    </Flex>
  );
};
